import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const AlertDialog = ({ secureId = "", open = false, onClose = () => {} }) => {
  const [copyText, setCopyText] = useState("Copy");
  const textAreaRef = useRef(null);

  const handleCopy = (e) => {
    textAreaRef.current.select();
    document.execCommand("copy");
    e.target.focus();
    setCopyText("Copied");
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Device ID</DialogTitle>
        <DialogContent>
          <textarea
            spellCheck={false}
            style={{
              resize: "none",
              border: "none",
              minWidth: "450px",
              width: "100%",
              outline: "none",
              color: "transparent",
              textShadow: "0px 0px 0px rgba(0, 0, 0, 0.54)",
              appearance: "none",
            }}
            ref={textAreaRef}
            id="alert-dialog-description"
            value={secureId}
            onChange={() => {}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
          <Button onClick={handleCopy} color="primary" autoFocus>
            {copyText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialog;
